import React from "react";
import { Helmet } from "react-helmet-async";

const SEO = ({
  title,
  description,
  path = "/",
  image = "/logo.png",
}) => {
  const fullTitle = title
    ? `${title} | RTC — Ragime Trading & Contracting WLL`
    : "RTC — Ragime Trading & Contracting WLL";
  const desc =
    description ||
    "RAGIME TRADING & CONTRACTING WLL (RTC) — Heavy equipment rental and road & construction contracting services in Doha, Qatar.";

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:image" content={image} />
      <meta property="og:url" content={`https://ragimetradingcontracting.com${path}`} />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      <meta name="twitter:image" content={image} />
      <link rel="canonical" href={`https://ragimetradingcontracting.com${path}`} />
    </Helmet>
  );
};

export default SEO;
